import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<p>{`To run your Doctocat site locally follow these steps:`}</p>
<ol>
<li parentName="ol">
<p parentName="li">{`If your site is located in a subfolder of your repository like `}<inlineCode parentName="p">{`/docs`}</inlineCode>{`, navigate to that folder in your terminal like so:
`}<inlineCode parentName="p">{`cd docs`}</inlineCode></p>
</li>
<li parentName="ol">
<p parentName="li">{`Install dependencies: `}<inlineCode parentName="p">{`yarn`}</inlineCode></p>
</li>
<li parentName="ol">
<p parentName="li">{`Run `}<inlineCode parentName="p">{`yarn run develop`}</inlineCode></p>
</li>
<li parentName="ol">
<p parentName="li">{`Go to `}<inlineCode parentName="p">{`localhost:8000`}</inlineCode>{` in your browser.`}</p>
</li>
</ol>
<p>{`If these steps don't work, check the README or reach out to the maintainer of the project you're working on. Some Doctocat sites may decide to customize their local development setup.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      